@if (isActive) {
    <div class="shutdown-blocker-overlay" aria-modal="true" role="alertdialog">
        <div class="shutdown-blocker-dialog">
            <hdmui-empty-states
                (buttonClick)="navigateBackToPortal()"
                [buttonText]="'APP.BACK_TO_H_PLUS' | translate"
                icon="hdmui:exclamationMarkCircled"
                type="error"
            >
                <hdmui-empty-states-title>
                    {{ 'DC.SERVICE_SHUTDOWN_BLOCKER.TITLE' | translate }}
                </hdmui-empty-states-title>
                <hdmui-empty-states-description>
                    {{ 'DC.SERVICE_SHUTDOWN_BLOCKER.MESSAGE' | translate }}
                </hdmui-empty-states-description>
            </hdmui-empty-states>
        </div>
    </div>
}
